import { useReducer, useContext, useEffect } from 'react';
import { BDPContext } from '../BoatDetailsPage';
import { PortalConfigContext } from '../../../../config/portal';
import { buildProduct } from '../../../../utils/dataLayerHelper';
import get from 'lodash/get';
import { useBdpHandlers, createCarouselButtons } from './bdpHelpers';
import { useDispatch, useSelector } from 'react-redux';
import {
  setProduct,
  setGenericEvent,
  setListingView
} from '../../../../store/actions/dataLayer';
import { createSearchAlert } from '../../../../store/actions';
import { defaultState } from './defaultState';

const reducer = (prevState, updated) => ({
  ...prevState,
  ...updated
});

export const useBdp = (props) => {
  const [state, setState] = useReducer(reducer, defaultState());
  const bdpContext = useContext(BDPContext);
  const portalConfigContext = useContext(PortalConfigContext);
  const dispatch = useDispatch();

  const handlers = useBdpHandlers(
    state,
    setState,
    props,
    portalConfigContext,
    dispatch
  );
  const { resizeHandler, handleResize, handleScroll } = handlers;

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    window.addEventListener('resize', resizeHandler);
    resizeHandler();

    let { listing } = props;
    if (listing && listing.id) {
      dispatch(setProduct(buildProduct(listing, 'boat')));
    }
    window.addEventListener('scroll', handleScroll);

    // GA4 Tracking for view_item event
    dispatch(setListingView(listing.id));

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  const id = get(props, 'listing.id');

  useEffect(() => {
    let { listing } = props;
    if (listing && listing.id) {
      dispatch(setProduct(buildProduct(listing, 'boat')));
    }
  }, [id]);

  const selectors = {
    userCountryCode: useSelector((state) => state.userCountryCode),
    additionalLeadsModalOpen: useSelector((state) =>
      get(state, 'app.additionalLeads.open', false)
    ),
    isLeadSubmitted: useSelector((state) =>
      get(state.app, 'trident.isLeadSubmitted', false)
    )
  };

  const setGenericEventAction = (...args) => {
    dispatch(setGenericEvent(...args));
  };

  const createSearchAlertAction = (...args) => {
    dispatch(createSearchAlert(...args));
  };

  const actions = {
    setGenericEventAction,
    createSearchAlertAction
  };

  const { mediaImages = [], mediaVideos = [] } = bdpContext;
  const carouselButtons = createCarouselButtons(
    mediaImages,
    mediaVideos,
    handlers.openCarousel
  );

  const bdp = { bdpContext, handlers, selectors, actions, carouselButtons };

  return {
    state,
    setState,
    bdp,
    configContext: portalConfigContext
  };
};
